export function isCaretOnLastLine(
  textareaElement: HTMLTextAreaElement
): boolean {
  const caret = Math.max(
    textareaElement.selectionStart,
    textareaElement.selectionEnd
  )

  // Create shadow elements - one for full text and one for text up to caret
  const shadowFull = document.createElement('div')
  const shadowCaret = document.createElement('div')

  // Copy essential textarea styles that affect text layout
  const essentialStyles = [
    'font-family',
    'font-size',
    'font-weight',
    'font-variant',
    'font-style',
    'letter-spacing',
    'line-height',
    'padding-left',
    'padding-right',
    'padding-top',
    'padding-bottom',
    'box-sizing',
    'border-width',
    'white-space',
    'word-wrap',
    'word-break',
    'text-rendering',
  ]

  const styles = window.getComputedStyle(textareaElement)

  // Apply essential styles to both shadow elements
  ;[shadowFull, shadowCaret].forEach((el) => {
    essentialStyles.forEach((style) => {
      el.style.setProperty(style, styles.getPropertyValue(style))
    })

    // Set common styles for measurement
    el.style.position = 'absolute'
    el.style.top = '0'
    el.style.left = '0'
    el.style.visibility = 'hidden'
    el.style.pointerEvents = 'none'
    el.style.overflow = 'hidden'
    el.style.height = 'auto'
    el.style.width = `${textareaElement.clientWidth}px`
    el.style.whiteSpace = 'pre-wrap' // Preserve whitespace and wrapping
  })

  // Set content
  shadowFull.textContent = textareaElement.value || ' '
  shadowCaret.textContent = textareaElement.value.substring(0, caret) || ' '

  // Append elements
  document.body.appendChild(shadowFull)
  document.body.appendChild(shadowCaret)

  // Get line counts by dividing total height by line height
  const fullHeight = shadowFull.offsetHeight
  const caretHeight = shadowCaret.offsetHeight
  const lineHeight = parseInt(styles.lineHeight) || parseInt(styles.fontSize)

  // Clean up
  document.body.removeChild(shadowFull)
  document.body.removeChild(shadowCaret)

  // Compare the line numbers
  const totalLines = Math.round(fullHeight / lineHeight)
  const caretLine = Math.round(caretHeight / lineHeight)

  return caretLine === totalLines
}
